import React from 'react'
import UserWidget2 from './UserWidget2'
import users from '../json/users.json'

const SampleUserWidget2 = () => <UserWidget2 users={users} amount={10} />

export default SampleUserWidget2



// WEBPACK FOOTER //
// ./src/user-widgets/SampleUserWidget2.js